import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.css']
})
export class HeroVideoComponent implements OnInit {

  @Input() homeHero_params: any = {}
  constructor() { }

  ngOnInit(): void {
  }

}
